import { useSelector } from "react-redux";
import { getText } from "./langHelper";

export const useText = (moduleName) => {
  const { selectedCountry } = useSelector((state) => state.countrySelection);
  const lang = selectedCountry?.lang || "en";
  return (key) => getText(moduleName, key, lang);
};